import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import HomePage from "./pages/HomePage";
import CruisePage from "./pages/CruisePage";
import HousesPage from "./pages/HousesPage";
import BikesPage from "./pages/BikesPage";
import BoatsPage from "./pages/BoatsPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";

import ScrollToTop from "./hooks/useScrollToTop";
import RouteSeo from "./components/RouteSeo";
import { LINKS } from "./config/links";
import LanguageSync from "./components/LanguageSync";

function App() {
  return (
    <>
      <ScrollToTop />
      <LanguageSync />
      <RouteSeo />

      <Routes>
        <Route
          path={LINKS.routes.home.pl}
          element={<HomePage />}
        />

        <Route
          path={LINKS.routes.home.en}
          element={<HomePage />}
        />

        <Route
          path={LINKS.routes.cruises.pl}
          element={<CruisePage />}
        />

        <Route
          path={LINKS.routes.cruises.en}
          element={<CruisePage />}
        />

        <Route
          path={LINKS.routes.houses.pl}
          element={<HousesPage />}
        />

        <Route
          path={LINKS.routes.houses.en}
          element={<HousesPage />}
        />

        <Route
          path={LINKS.routes.bikes.pl}
          element={<BikesPage />}
        />

        <Route
          path={LINKS.routes.bikes.en}
          element={<BikesPage />}
        />

        <Route
          path={LINKS.routes.boats.pl}
          element={<BoatsPage />}
        />

        <Route
          path={LINKS.routes.boats.en}
          element={<BoatsPage />}
        />

        <Route
          path={LINKS.routes.privacy.pl}
          element={<PrivacyPolicy lang="pl" />}
        />

        <Route
          path={LINKS.routes.privacy.en}
          element={<PrivacyPolicy lang="en" />}
        />

        <Route
          path="*"
          element={
            <Navigate
              to={LINKS.routes.home.pl}
              replace
            />
          }
        />
      </Routes>
    </>
  );
}

export default App;